import { PageTitle as SharedPageTitle } from '../components/layout/PageHeader';
import styled from 'styled-components';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { useComplianceDocument } from '../hooks/useApi';
import { ComplianceForm } from '../features/compliance/components/ComplianceForm';

const PageContainer = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 52rem;
  margin: 0;
  padding: 0;
`;

const Header = styled.div`
  margin-bottom: var(--space-lg);
`;

const Title = styled(SharedPageTitle)``;

const Subtitle = styled.p`
  margin: 0.5rem 0 0;
  max-width: 65ch;
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--text-muted);
`;

export const ComplianceRenewPage = () => {
  const navigate = useNavigate();
  const { documentId } = useParams<{ documentId?: string }>();
  const { data, isLoading, error, refetch } = useComplianceDocument(documentId);

  if (!documentId) {
    return <Navigate to="/compliance" replace />;
  }

  return (
    <PageContainer>
      <Header>
        <Title>Renovar documento</Title>
        <Subtitle>
          Actualiza la fecha de vencimiento y, si es necesario, reemplaza el
          archivo.
        </Subtitle>
      </Header>

      {isLoading ? (
        <Card>
          <LoadingSpinner message="Cargando documento..." />
        </Card>
      ) : error || !data ? (
        <Card>
          <p style={{ margin: 0, color: 'var(--danger-600)' }}>
            No se pudo cargar el documento.
          </p>
          <div style={{ marginTop: 'var(--space-md)' }}>
            <Button variant="secondary" onClick={() => refetch()}>
              Reintentar
            </Button>
          </div>
        </Card>
      ) : (
        <ComplianceForm
          mode="renew"
          document={data}
          onCancel={() => navigate(`/compliance/${documentId}`)}
          onSuccess={(id) => navigate(`/compliance/${id}`)}
        />
      )}
    </PageContainer>
  );
};

ComplianceRenewPage.displayName = 'ComplianceRenewPage';
